import { AppDirective } from '../App';
import type { AppPlugin } from '../Plugin';
import { createInterruptedError } from '../AppError';

declare module '../Def' {
    interface AppPluginOptions {
        safe?: boolean;
    }
}

export function createSafeModePlugin<AdditionalOptions, CustomProps>(): AppPlugin<AdditionalOptions, CustomProps> {
    return ({ app, debug }) => {
        app.hooks.waitForLoadingOrBootstrappingWhenStop.tap('SafeModePlugin', () => {
            return {
                wait: !!app.options.safe,
            };
        });

        if (!app.options.safe) {
            app.lifecycle.hooks.mount.tapPromise('SafeModePlugin', () => {
                debug('mount');
                return app.lifecycle.fns
                    .call('mount', app.lifecycle.customProps, false, (index: number, total: number): void => {
                        if (
                            (app.latestDirective === AppDirective.STOP ||
                                app.latestDirective === AppDirective.UNLOAD) &&
                            index < total - 1
                        ) {
                            throw createInterruptedError(`${app} mounting suspended.`);
                        }
                    })
                    .then(() => 'do it');
            });

            app.lifecycle.hooks.update.tapPromise('SafeModePlugin', ({ params: customProps }) => {
                debug('update');
                return app.lifecycle.fns
                    .call(
                        'update',
                        { ...app.lifecycle.customProps, ...customProps },
                        false,
                        (index: number, total: number) => {
                            if (
                                (app.latestDirective === AppDirective.STOP ||
                                    app.latestDirective === AppDirective.UNLOAD) &&
                                index < total - 1
                            ) {
                                throw createInterruptedError(`${app} updating suspended.`);
                            }
                        }
                    )
                    .then(() => 'do it');
            });
        }
    };
}
